var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.89 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#ff000f;}.cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.63 31.94 0 62 15.66 62 20.04 48.85 30.06 48.85 30.06 31.94 10.63 31.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.06 0 21.92 0 11.29 30.06 30.06 30.06 30.06 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.94 48.85 41.96 48.85 46.35 62 62 62 51.37 31.94 31.94 31.94 31.94 48.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.71 30.06 40.08 0 31.94 0 31.94 30.06 50.71 30.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.29,30.06a20.13,20.13,0,0,0-7.36-6.12A13.15,13.15,0,0,0,143.41,0H139V30.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139,31.94V62h3.13a19.77,19.77,0,0,0,19.73-20,19.7,19.7,0,0,0-2.38-10Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 118.36,
    width: 18.79,
    height: 30.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 118.36,
    y: 31.94,
    width: 18.79,
    height: 30.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.56,30.06a20.05,20.05,0,0,0-7.36-6.12A13.15,13.15,0,0,0,92.69,0H88.3V30.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.3,31.94V62h3.13a19.77,19.77,0,0,0,19.73-20,19.7,19.7,0,0,0-2.38-10Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 67.64,
    width: 18.79,
    height: 30.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 67.64,
    y: 31.94,
    width: 18.79,
    height: 30.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbLogo);
export default __webpack_public_path__ + "static/media/abb-logo.7511957e203573a812585a934f00ea0e.svg";
export { ForwardRef as ReactComponent };